exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-area{margin:10px}.close-ticket{z-index:1000}.close-ticket .md-dialog-container{height:auto}.star-container{font-size:0}.star-container .md-icon{color:gold!important}.rating-container{display:flex;flex-direction:column}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./Components/supportNew/closeTicket.vue
// module id = 415
// module chunks = 0